<template>
	<section class="small-12 columns pageNav flex">
		<nav class="small-12 columns">
			<ul class="small-12 flex vertical-align border-bottom">
				<li class="flex vertical-align">
					<router-link class="flex vertical-align justify-center" :to="{ name: 'PropertiesDashboard' }">
						Properties
					</router-link>
				</li>
			</ul>
		</nav>
	</section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertiesNav',

	}

</script>